var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-685.000000, -442.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(685.000000, 442.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D8D8D8",
    cx: 35,
    cy: 35,
    r: 35
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_remove_shopping_cart_48px",
    transform: "translate(19.000000, 19.000000)",
    fill: "#7F7F7F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,30.2120546 L3.89969204,2.11174659 L2.81566212,1.02771667 L1.78794545,0 L0,1.78794545 L6.18037835,7.9683238 L9.291685,14.5288165 L7.39111307,17.9780026 C7.1658601,18.3721953 7.0391553,18.8367796 7.0391553,19.3295205 C7.0391553,20.8781346 8.30620326,22.1451826 9.85481742,22.1451826 L20.3572371,22.1451826 L22.300044,24.0879894 C21.5961285,24.6018478 21.1315442,25.4324681 21.1315442,26.3686758 C21.1315442,27.9172899 22.3845139,29.1843379 23.933128,29.1843379 C24.8693357,29.1843379 25.699956,28.7127145 26.2138143,28.0017598 L30.2120546,32 L32,30.2120546 Z M10.4461065,19.3295205 C10.2490101,19.3295205 10.0941487,19.174659 10.0941487,18.9775627 L10.1363836,18.808623 L11.4034316,16.5138583 L14.7259129,16.5138583 L17.541575,19.3295205 L10.4461065,19.3295205 Z M21.891773,16.5138583 C22.9476463,16.5138583 23.8768148,15.9366476 24.3554773,15.0637923 L29.3955125,5.92696876 C29.508139,5.72987242 29.5644523,5.49054114 29.5644523,5.25120985 C29.5644523,4.47690277 28.9309283,3.84337879 28.1566212,3.84337879 L9.20721513,3.84337879 L21.8776947,16.5138583 L21.891773,16.5138583 L21.891773,16.5138583 Z M9.85481742,23.5530136 C8.30620326,23.5530136 7.05323361,24.8200616 7.05323361,26.3686758 C7.05323361,27.9172899 8.30620326,29.1843379 9.85481742,29.1843379 C11.4034316,29.1843379 12.6704795,27.9172899 12.6704795,26.3686758 C12.6704795,24.8200616 11.4034316,23.5530136 9.85481742,23.5530136 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartEmpty);
export default __webpack_public_path__ + "static/media/cart-empty.fa110a0b50c152fbee7a420e39ca98ea.svg";
export { ForwardRef as ReactComponent };